import React from 'react'
import { Link } from 'react-router-dom'
import { Breadcrumb } from 'antd'
import './index.less'

function Bread(list, info) {
  return (
    <div className="Bread">
      <Breadcrumb separator=">">
        <Breadcrumb.Item>
          <img src={require('../../static/home.svg')} alt="" />
          <Link to="/">{info ? info.infoType : list[0].title}</Link>
        </Breadcrumb.Item>
        {list.map((item, index) => (
          <Breadcrumb.Item key={index}>
            <Link to={item.url ? item.url : null}>{info ? info.name : item.title}</Link>
          </Breadcrumb.Item>
        ))}
      </Breadcrumb>
    </div>
  )
}

export default Bread
